export const DEFAULT_ERP_PIECE_UNIT_OF_MEASURE = 'PZ';

export function normalizeErpPieceUnitOfMeasure(value: unknown): string {
    if (typeof value !== 'string') return DEFAULT_ERP_PIECE_UNIT_OF_MEASURE;
    return value.trim().toUpperCase() || DEFAULT_ERP_PIECE_UNIT_OF_MEASURE;
}
